/* MIKOO product page extras: wall-size drawing, delivery date, framed/print-only line,
   add-to-cart feedback, the phone buy bar and "complete the wall". */
(function () {
  var GAP_CM = 10; /* space between pictures in a set, as the owner recommends */
  var BUSINESS_DAYS = 14; /* from the shipping page: up to 14 business days */
  var WOOD = 1.5;
  var METAL = 0.7;
  var NO_FRAME = 'ללא מסגרת';
  /* same colours as the live frame preview (sampled from the real frame photos) */
  var FRAME_COLOURS = { 'עץ שחור': '#121214', 'עץ טבעי': '#e6c88f', 'עץ מולבן': '#f1e8d9', 'עץ אלון': '#bfa074', 'אלומיניום שחור': '#0c0c0e', 'אלומיניום לבן': '#efefef' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function selectedValues() {
    var root = document.querySelector('variant-selects');
    var values = [];
    if (!root) return values;
    root.querySelectorAll('input[type="radio"]:checked').forEach(function (input) { values.push(input.value); });
    root.querySelectorAll('select').forEach(function (select) { values.push(select.value); });
    return values;
  }

  function sizeFromValues(values) {
    for (var i = 0; i < values.length; i++) {
      var match = /^([0-9]+) *[xX] *([0-9]+)$/.exec(values[i].trim());
      if (match) return { w: parseInt(match[1], 10), h: parseInt(match[2], 10) };
    }
    return null;
  }

  /* sets sold in size pairs such as "70x70 + 50x70": one {w, h} per picture, by shape (as comboSizes in mikoo-frame.js) */
  function comboFromValues(values, ratios) {
    for (var i = 0; i < values.length; i++) {
      var parts = values[i].split('+');
      if (parts.length < 2) continue;
      var sizes = parts.map(function (p) { var m = /^\s*([0-9]+)\s*[xX×]\s*([0-9]+)\s*$/.exec(p); return m ? { w: +m[1], h: +m[2] } : null; });
      if (sizes.some(function (s) { return !s; })) continue;
      return ratios.map(function (r) {
        var best = -1;
        sizes.forEach(function (s, k) {
          if (s.used) return;
          if (best < 0 || Math.abs(Math.log(r / (s.w / s.h))) < Math.abs(Math.log(r / (sizes[best].w / sizes[best].h)))) best = k;
        });
        if (best < 0) return { w: sizes[0].w, h: sizes[0].h };
        sizes[best].used = true;
        return { w: sizes[best].w, h: sizes[best].h };
      });
    }
    return null;
  }

  function profileFromValues(values) {
    for (var i = 0; i < values.length; i++) {
      if (values[i].indexOf(NO_FRAME) > -1) return { cm: 0, framed: false };
      if (values[i].indexOf('אלומיניום') === 0) return { cm: METAL, framed: true };
      if (values[i].indexOf('עץ') === 0) return { cm: WOOD, framed: true };
    }
    return { cm: WOOD, framed: true };
  }

  /* The unframed pictures, from the product's image file names. Usually they end in 1 (framed: 2, room: 3).
     Before comparing, Shopify's _<uuid> and _<n> suffixes for repeated names are removed (a uuid can end in 1).
     When the product has a framed picture ("…2"), only the "…1" with the same name counts (so a room picture
     like "…no131" next to "…no11" / "…no12" is left out). Old uploads with no number: the unframed picture is
     named like the framed one without the 2. Same rule as snippets/mikoo-frame-stage.liquid.
     isPlain(src, all): all = every image of the product (srcs or objects with .src). */
  function stemOf(src) {
    var m = /([^/]+)[.](jpe?g|png|webp)$/i.exec(String(src || '').split('?')[0]);
    return m ? m[1].replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '').replace(/_[0-9]+$/, '') : null;
  }
  function plainStems(all) {
    var stems = (all || []).map(function (x) { return stemOf(typeof x === 'string' ? x : x && (x.src || x.url)); }).filter(Boolean);
    var ones = stems.filter(function (s) { return /1$/.test(s); });
    var bases = stems.filter(function (s) { return /2$/.test(s); }).map(function (s) { return s.slice(0, -1); });
    var matched = ones.filter(function (s) { return bases.indexOf(s.slice(0, -1)) > -1; });
    if (matched.length) return matched;
    if (ones.length) return ones;
    return stems.filter(function (s) { return !/[0-9]$/.test(s) && stems.indexOf(s + '2') > -1; });
  }
  function isPlain(src, all) {
    var stem = stemOf(src);
    return !!stem && plainStems(all && all.length ? all : [src]).indexOf(stem) > -1;
  }

  function handle() {
    var part = location.pathname.split('/products/')[1];
    return part ? decodeURIComponent(part.split('/')[0]) : null;
  }

  var productPromise = null;
  function productJson() {
    if (!productPromise && handle()) {
      productPromise = fetch('/products/' + handle() + '.js').then(function (r) { return r.json(); });
    }
    return productPromise;
  }

  /* ---------- wall-size drawing ---------- */
  var pictures = 1;
  var pictureUrls = [];
  var pictureRatios = [];
  var landscape = false; /* sizes are written width first for portrait pictures; a landscape one hangs the other way */

  function renderWall() {
    var box = document.querySelector('.mk-wall');
    if (!box) return;
    var values = selectedValues();
    var frame = profileFromValues(values);
    var each = comboFromValues(values, pictureRatios);
    if (!each) {
      var size = sizeFromValues(values);
      if (!size) { box.hidden = true; return; }
      if (landscape && size.w < size.h) size = { w: size.h, h: size.w };
      each = [];
      for (var p = 0; p < pictures; p++) each.push(size);
    }
    each = each.map(function (s) { return { w: s.w + 2 * frame.cm, h: s.h + 2 * frame.cm }; });
    var h = Math.max.apply(null, each.map(function (s) { return s.h; }));
    var totalW = each.reduce(function (t, s) { return t + s.w; }, 0) + (each.length - 1) * GAP_CM;

    /* the drawing shows a 320 cm wide, 230 cm high wall; a wider set widens the wall */
    var wallW = Math.max(320, totalW + 60);
    var wallH = 230;
    var stage = box.querySelector('.mk-wall__stage');
    var art = box.querySelector('.mk-wall__art');
    stage.style.setProperty('--mk-wall-ratio', wallW / wallH);
    var sofa = box.querySelector('.mk-wall__sofa');
    sofa.style.width = (200 / wallW) * 100 + '%';
    sofa.style.height = (85 / wallH) * 100 + '%';

    /* frames hang 25 cm above the sofa back */
    while (art.children.length < each.length) art.appendChild(document.createElement('span'));
    while (art.children.length > each.length) art.removeChild(art.lastChild);
    /* show the real pictures inside the drawn frames; each one as wide and tall as its own size */
    Array.prototype.forEach.call(art.children, function (span, i) {
      var url = pictureUrls[i % (pictureUrls.length || 1)];
      if (url && !span.style.backgroundImage) span.style.backgroundImage = 'url("' + url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=300")';
      span.style.flexGrow = each[i].w;
      span.style.alignSelf = 'center';
      span.style.height = (each[i].h / h) * 100 + '%';
    });
    art.style.width = (totalW / wallW) * 100 + '%';
    art.style.height = (h / wallH) * 100 + '%';
    art.style.bottom = ((85 + 25) / wallH) * 100 + '%';
    art.style.gap = (GAP_CM / totalW) * 100 + '%';
    art.classList.toggle('is-unframed', !frame.framed);
    var colour = values.map(function (v) { return FRAME_COLOURS[v]; }).filter(Boolean)[0];
    art.style.setProperty('--mk-frame-colour', colour || '#1c1c1e');

    var fits = Math.ceil(totalW / 0.66 / 10) * 10; /* art reads best at about 2/3 of the furniture below it */
    box.querySelector('.mk-wall__caption').innerHTML =
      'על הקיר, ביחס לספה של 2 מטר: <strong>כ-' + Math.round(totalW) + ' × ' + Math.round(h) + ' ס״מ</strong>' +
      (each.length > 1 ? ' (' + each.length + ' תמונות, ' + GAP_CM + ' ס״מ ביניהן)' : '') +
      (fits < 100 ? '<br>מתאים לשידה, למדף או לקיר צר' : '<br>מתאים מעל ספה או שידה ברוחב של כ-' + fits + ' ס״מ');
    box.hidden = false;
  }

  function initWall() {
    if (!document.querySelector('.mk-wall')) return;
    productJson().then(function (product) {
      var plain = (product.media || []).filter(function (m, i, all) { return m.media_type === 'image' && isPlain(m.src, all); });
      pictureUrls = plain.map(function (m) { return m.src; });
      pictures = Math.max(1, plain.length);
      pictureRatios = plain.map(function (m) { return m.width && m.height ? m.width / m.height : 0.75; });
      landscape = !!(plain[0] && plain[0].width > plain[0].height * 1.05);
      renderWall();
    }).catch(function () {});
  }

  /* ---------- delivery date and the framed / print-only line ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay(); /* Israeli work week: Sunday to Thursday */
      if (day !== 5 && day !== 6) days--;
    }
    return d;
  }

  function renderPromise() {
    var dayNames = ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'];
    var el = document.querySelector('[data-mk-delivery]');
    if (el) {
      var d = addBusinessDays(new Date(), BUSINESS_DAYS);
      el.textContent = 'עד יום ' + dayNames[d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1);
    }
    var line = document.querySelector('[data-mk-frame-line] .mk-promise__text');
    if (line) {
      var hasPrint = line.parentElement.hasAttribute('data-mk-has-print');
      line.textContent = !profileFromValues(selectedValues()).framed
        ? 'הדפסה בלבד (פוסטר), בלי מסגרת. מוכנה למסגור'
        : hasPrint
          ? 'מגיע ממוסגר ומוכן לתלייה. אפשר לבחור גם הדפסה בלבד, בלי מסגרת'
          : 'מגיע ממוסגר ומוכן לתלייה';
    }
  }

  /* ---------- add-to-cart feedback: the button confirms, the bag count bumps, same moment ---------- */
  function onAdded() {
    var button = document.querySelector('product-form .product-form__submit');
    var label = button && button.querySelector('span');
    if (label && !button.classList.contains('mk-added')) {
      var original = label.textContent;
      button.classList.add('mk-added');
      label.textContent = '✓ נוסף לסל';
      setTimeout(function () { label.textContent = original; button.classList.remove('mk-added'); }, 1800);
    }
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble && !reduceMotion) {
      bubble.classList.remove('mk-bump');
      void bubble.offsetWidth;
      bubble.classList.add('mk-bump');
    }
    if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
  }

  /* ---------- phone buy bar ---------- */
  function initSticky() {
    var bar = document.querySelector('.mk-sticky');
    var main = document.querySelector('product-form .product-form__submit');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var mainVisible = true;
    var footerVisible = false;
    function update() {
      var rect = main.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      var show = !mainVisible && scrolledPast && !footerVisible;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting; update(); }).observe(main);
    var footer = document.querySelector('footer');
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);

    bar.querySelector('.mk-sticky__button').addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });
    syncSticky();
  }

  function syncSticky() {
    var bar = document.querySelector('.mk-sticky');
    var main = document.querySelector('product-form .product-form__submit');
    if (!bar || !main) return;
    var price = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    var visiblePrice = Array.prototype.find.call(document.querySelectorAll('[id^="price-"] .price__container .price-item'), function (el) { return el.offsetParent !== null; }) || price;
    if (visiblePrice) bar.querySelector('.mk-sticky__price').textContent = visiblePrice.textContent.trim();
    var button = bar.querySelector('.mk-sticky__button');
    button.disabled = main.disabled;
    button.textContent = main.disabled ? (main.textContent.trim() || 'אזל מהמלאי') : 'הוספה לסל';
  }

  /* ---------- complete the wall ---------- */
  function initCompleteWall() {
    var box = document.querySelector('.mk-complete');
    if (!box) return;
    fetch(box.dataset.map).then(function (r) { return r.json(); }).then(function (map) {
      var sets = (map[box.dataset.handle] || []).slice(0, 2);
      if (!sets.length) return;
      return Promise.all(sets.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var list = box.querySelector('.mk-complete__list');
        products.filter(Boolean).forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'mk-complete__card';
          a.href = p.url;
          var img = new Image();
          img.loading = 'lazy';
          img.alt = '';
          img.src = (p.featured_image || '') + ((p.featured_image || '').indexOf('?') > -1 ? '&' : '?') + 'width=500';
          var info = document.createElement('span');
          info.className = 'mk-complete__info';
          var name = document.createElement('span');
          name.className = 'mk-complete__name';
          name.textContent = p.title;
          var price = document.createElement('span');
          price.className = 'mk-complete__price';
          price.textContent = 'קיר שלם החל מ-' + formatMoney(p.price_min);
          var go = document.createElement('span');
          go.className = 'mk-complete__go';
          go.textContent = 'לצפייה בקיר ‹';
          info.append(name, price, go);
          a.append(img, info);
          list.appendChild(a);
        });
        if (list.children.length) box.hidden = false;
      });
    }).catch(function () {});
  }

  function formatMoney(cents) {
    var value = cents / 100;
    return '₪' + (value % 1 === 0 ? value.toLocaleString('he-IL') : value.toLocaleString('he-IL', { minimumFractionDigits: 2 }));
  }

  /* ---------- reviews: load Yotpo's widget only when the section is near the screen ---------- */
  function initReviews() {
    var widget = document.querySelector('.mk-reviews__widget');
    if (!widget) return;
    function load() {
      if (widget.dataset.loaded) return;
      widget.dataset.loaded = '1';
      var s = document.createElement('script');
      s.async = true;
      s.src = widget.dataset.yotpoSrc;
      document.head.appendChild(s);
    }
    /* the reviews fade in once Yotpo has drawn them, instead of popping into the page */
    if (window.MutationObserver && widget.animate) {
      var drawn = new MutationObserver(function () {
        if (!widget.querySelector('#yotpo-testimonials-custom-tab > *')) return;
        drawn.disconnect();
        widget.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 360, easing: 'ease-out' });
      });
      drawn.observe(widget, { childList: true, subtree: true });
    }
    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { load(); io.disconnect(); }
    }, { rootMargin: '600px 0px' });
    io.observe(widget);
  }

  /* ---------- price: when a size or frame changes the price, the new one rises in, so the eye goes to it ---------- */
  var lastPrice = null;
  function priceBox() { return document.querySelector('[id^="price-"][role="status"]'); }
  function priceText(box) { return box ? box.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function animatePrice() {
    var box = priceBox();
    var text = priceText(box);
    if (lastPrice === null || text === lastPrice) { lastPrice = text; return; }
    lastPrice = text;
    if (!box.animate) return;
    var frames = reduceMotion
      ? [{ opacity: 0.2 }, { opacity: 1 }]
      : [{ opacity: 0, transform: 'translateY(0.6rem)' }, { opacity: 1, transform: 'none' }];
    box.animate(frames, { duration: reduceMotion ? 160 : 280, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
  }

  /* ---------- rating link: glide down to the reviews and keep the place in history ---------- */
  function initRatingLink() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.mk-rating[href^="#"]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', link.getAttribute('href'));
    });
  }

  function onVariantChange() {
    animatePrice();
    renderWall();
    renderPromise();
    syncSticky();
  }

  function init() {
    lastPrice = priceText(priceBox());
    initWall();
    renderPromise();
    initSticky();
    initCompleteWall();
    initReviews();
    initRatingLink();
    /* Dawn's pubsub names are top-level consts in constants.js, not window properties */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(onVariantChange, 0); });
      /* Dawn redraws the bag icon right after this event, so act on the next tick: button and count change together */
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { if (event && event.source === 'product-form') setTimeout(onAdded, 0); });
    } else {
      document.addEventListener('change', function (event) {
        if (event.target.closest && event.target.closest('variant-selects')) setTimeout(onVariantChange, 400);
      });
    }
  }

  /* this file loads before Dawn's scripts, so start once they have all run */
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
